import React from 'react';
import { connect } from 'react-redux';
import { DBSpecDropDownObjective, ObjectiveFlag } from '_components';
import styles from './Common.module.css'

class SpecTestsNoSidePosNegPanel extends React.Component {

    render() {

        return (
            <div key={this.props.panel.MOPNO} className={styles.dropdown_row}>
                <ObjectiveFlag className={styles.flag} flagged={this.props.includeFlags !== undefined && this.props.includeFlags === false ? false : this.props.flagged} mopno={this.props.panel.MOPNO} flagText={this.props.header + ' - ' + this.props.panel.MOPLABEL} />
                <span className={styles.spacer} />
                <label className={styles.label}>{this.props.panel.MOPLABEL}</label>
                <span className={styles.r} />
                <DBSpecDropDownObjective
                    field={this.props.panel.MOPCOLUMNPREFIX}
                    noteId={this.props.noteId}
                    entity='PTOBJECTIVESPECTESTS'
                    entityKeyColumn='TSNO'
                    entityKeyValue={this.props.tsno}
                    className={styles.c}
                    optionsValue={1}
                />
                <span className={styles.l} />
            </div>
        );
    }

}

function mapStateToProps(state, ownprops) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let tsno = parseInt(Object.keys(state.entities.notes.PTOBJECTIVESPECTESTS)
        .find(key => (state.entities.notes.PTOBJECTIVESPECTESTS[key].TSEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVESPECTESTS[key].TSNTNO === pk && noteType !== 1)));
    let panel = state.entities.masterData.PTMASTEROBJECTIVEPANELS[ownprops.panelId];
    let reverseFlag = ownprops.reverseFlag ? true : false;
    let flagVal = 1;
    if (reverseFlag) {
        flagVal = 2;
    }

    return {
        noteId: noteId,
        tsno: tsno,
        flagged: state.entities.notes.PTOBJECTIVESPECTESTS[tsno][panel.MOPCOLUMNPREFIX] === flagVal ? true : false,
        panel: panel
    };
}

const connectedSpecTestsNoSidePosNegPanel = connect(mapStateToProps)(SpecTestsNoSidePosNegPanel);
export { connectedSpecTestsNoSidePosNegPanel as SpecTestsNoSidePosNegPanel };


